<template lang="pug">
div
  el-card(shadow='hover').card-collapse
    app-header-dados-processo(
      :processo="processo",
      :isCCR="isCCR"
      :dadosCadastros="dadosCadastros"
    )
  el-card(shadow="hover").card-container
    div
      el-steps.card-container(:active='active', finish-status='success', simple, v-if="!isAcusarEntrega")
        el-step(title='Informações para emissão do DAR')
        el-step(title='Emissão do DAR')

      validation-observer(ref='validation' tag='div', v-if="active === 0 && !isAcusarEntrega")
      div(v-if="active === 0")
        informacoes-dar(
          :parcela="parcela"
        )
      div(v-if="active === 1")
        informacoes-emissao-dar(
          :parcela="parcela"
          :isAcusarEntrega="isAcusarEntrega"
          @uploadFile="salvarBoleto"
          @atualizaNumeroDar="atualizaNumeroDar"
          @atualizarData="atualizarData"
        )

      app-buttons-cadastro(
        :showButtonCancelar='true',
        :showButtonVoltar='!isAcusarEntrega'
        :showButtonProximo='true',
        :isUltimoPasso="isUltimoPasso",
        :isPrimeiroPasso="isPrimeiroPasso || isAcusarEntrega",
        @proximo="proximo",
        @voltar="voltar",
        @cancelar='cancelar',
        @finalizar='finalizar'
      )
</template>

<script>
import { mapActions } from 'vuex'
import InformacoesDar from './components/InformacoesDar.vue'
import AppHeaderDadosProcesso from '@/components/AppHeaderDadosProcesso.vue'
import AppButtonsCadastro from '@/components/AppButtonsCadastro.vue'
import InformacoesEmissaoDar from './components/InformacoesEmissaoDar.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao.vue'

export default {
  components: {
    AppHeaderDadosProcesso,
    AppButtonsCadastro,
    InformacoesDar,
    InformacoesEmissaoDar
  },

  mixins: [AppNotificacao],

  props: {
    processo: {
      type: Object,
      required: true
    },

    isAcusarEntrega: {
      type: Boolean,
      required: false,
      default: false
    },

    isGerenciar: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      active: 0,
      isCCR: false,
      dadosCadastros: {
        despacho: {
          id: '0'
        }
      },
      vtnRequest: {
        areaRequerida: '',
        moduloFiscal: '',
        qtdModuloFiscal: '',
        municipio: {
          id: '',
          nome: ''
        },
        pvtn: {
          vtnPorHaMinFormatado: ''
        }
      },
      boleto: '',
      boletoDTO: {
        id: '',
        dataEmissao: new Date(),
        dataPagamento: '',
        numeroDar: '',
        boletoDoc: null,
        comprovantePagamento: null,
        parcela: {}
      },
      parcela: {}
    }
  },

  computed: {
    isPrimeiroPasso () {
      return this.active === 0
    },

    isUltimoPasso () {
      return this.active === 1
    }
  },

  async created () {
    this.parcela = this.$route.params.parcela
    const processo = await this.getProcesso(this.processo.numeroProtocolo)
    this.dadosVtn = await this.getVtnByIdProcesso(processo.id)
    this.active = this.isAcusarEntrega ? 1 : 0
    this.vtnRequest = {
      ...this.vtnRequest,
      id: this.dadosVtn.id,
      processo: {
        id: processo.id
      },
      areaRequerida: this.dadosVtn.areaRequerida,
      qtdModuloFiscal: this.dadosVtn.nModuloFiscal,
      moduloFiscal: this.dadosVtn.pvtn.municipio.mf,
      municipio: {
        id: this.dadosVtn.pvtn.municipio.id,
        nome: this.dadosVtn.pvtn.municipio.nome
      },
      pvtn: this.dadosVtn.pvtn
    }
  },

  methods: {
    ...mapActions({
      getProcesso: 'processos/getProcessoByProtocolo',
      getVtnByIdProcesso: 'vtn/getVtnbyIdProcesso',
      updateVtn: 'vtn/updateVtn',
      uploadBoleto: 'vtn/salvarBoleto',
      criarBoleto: 'vtn/criarBoleto',
      updateParcelas: 'vtn/updateParcelas'
    }),
    async proximo () {
      this.active = this.active + 1
    },

    voltar () {
      this.active = this.active - 1
    },

    async finalizar () {
      if (this.boletoDTO.numeroDar === '' && !this.isAcusarEntrega) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.mensagemNumDARVazio()
        )
      }

      if (!this.boleto || this.boleto.length === 0) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.mensagemBoletoVazio()
        )
      }

      this.boleto[0].tipo = this.isAcusarEntrega ? 'COMPROVANTE' : 'DAR'
      if (this.isAcusarEntrega) {
        this.boletoDTO.comprovantePagamento = await this.uploadBoleto(this.boleto)
      } else {
        this.boletoDTO.boletoDoc = await this.uploadBoleto(this.boleto)
      }

      this.dadosVtn.parcelasAp.sort((p1, p2) => {
        if (p1.numero < p2.numero) {
          return -1
        } else {
          return 1
        }
      })

      const parcelaAtual = this.dadosVtn.parcelasAp.find(p => p.id === this.parcela.id)

      if (this.isAcusarEntrega) {
        this.boletoDTO.id = parcelaAtual.boleto.id
      }

      this.boletoDTO.parcela = parcelaAtual

      const boleto = await this.criarBoleto(this.boletoDTO)

      parcelaAtual.status = this.isAcusarEntrega ? 'PAGA' : 'EMITIDA'

      parcelaAtual.boleto = boleto

      this.dadosVtn.parcelasAp.forEach(p => {
        if (p.id === parcelaAtual.id) {
          p = parcelaAtual
        }
      })

      this.vtnRequest.parcelasAp = this.dadosVtn.parcelasAp
      this.vtnRequest.status = this.dadosVtn.status
      this.vtnRequest.formaPagamento = this.dadosVtn.formaPagamento
      this.vtnRequest.status = this.vtnRequest.status.toUpperCase()

      this.vtnRequest.parcelasAp.forEach(p => {
        if (p.boleto && p.boleto.dataEmissao) {
          const date = p.boleto.dataEmissao.split('/')
          const dataEmissao = [parseInt(date[2]), parseInt(date[1]), parseInt(date[0]), 1, 2, 3, 4]
          p.boleto.dataEmissao = dataEmissao
        }
      })

      if ((this.boletoDTO.boletoDoc !== null && this.boletoDTO.numeroDar !== '') || (this.boletoDTO.comprovantePagamento !== null)) {
        await this.updateParcelas([parcelaAtual])

        await this.updateVtn(this.vtnRequest)
        this.$router.push({
          name: 'gerenciar-vtn',
          params: {
            processo: this.processo,
            vtn: this.dadosVtn,
            isGerenciar: true
          }
        })

        if (this.isAcusarEntrega) {
          this.showNotificacao(
            this.$messages.TIPO_SUCCESS,
            this.$messages.TITULO_SUCCESS,
            this.mensagemPagamentoAcusado()
          )
        } else {
          this.showNotificacao(
            this.$messages.TIPO_SUCCESS,
            this.$messages.TITULO_SUCCESS,
            this.mensagemDarEmitido()
          )
        }
      }
    },

    cancelar () {
      this.$router.push({
        name: 'gerenciar-vtn',
        params: {
          processo: this.processo,
          vtn: this.dadosVtn,
          isGerenciar: true
        }
      })
    },

    mensagemDarEmitido () {
      return 'Pagamento acusado.'
    },

    mensagemPagamentoAcusado () {
      return 'Pagamento acusado com sucesso!'
    },

    mensagemNumDARVazio () {
      return 'Preencha o número do DAR!'
    },

    mensagemBoletoVazio () {
      return this.isAcusarEntrega ? 'Insira o comprovante de pagamento!' : 'Insira o boleto!'
    },

    salvarBoleto (file) {
      this.boleto = file
    },

    atualizaNumeroDar (numeroDar) {
      this.boletoDTO.numeroDar = numeroDar
    },

    atualizarData (data) {
      this.boletoDTO.dataEmissao = data
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/EmitirDar.vue